export const SoundBox: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.867"
      height="40.3"
      viewBox="0 0 24.867 40.3"
      {...props}
    >
      <g transform="translate(-3257.956 -3168.623)">
        <g transform="translate(3269.322 3177.832)">
          <path
            d="M3389.205,3275.941a1.068,1.068,0,1,1,1.068-1.068A1.069,1.069,0,0,1,3389.205,3275.941Z"
            transform="translate(-3388.137 -3273.805)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.3"
          />
        </g>
        <g transform="translate(3258.106 3168.773)">
          <path
            d="M3278.1,3206.606h-15.43a4.574,4.574,0,0,1-4.569-4.569v-28.7a4.574,4.574,0,0,1,4.569-4.569h15.43a4.574,4.574,0,0,1,4.569,4.569v28.7A4.574,4.574,0,0,1,3278.1,3206.606Zm-15.43-36.626a3.365,3.365,0,0,0-3.361,3.362v28.7a3.365,3.365,0,0,0,3.361,3.361h15.43a3.365,3.365,0,0,0,3.361-3.361v-28.7a3.365,3.365,0,0,0-3.361-3.362Z"
            transform="translate(-3258.106 -3168.773)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.3"
          />
        </g>
        <g transform="translate(3262.428 3185.341)">
          <path
            d="M3316.173,3376.778a7.962,7.962,0,1,1,7.962-7.962A7.971,7.971,0,0,1,3316.173,3376.778Zm0-14.717a6.755,6.755,0,1,0,6.755,6.755A6.762,6.762,0,0,0,3316.173,3362.062Z"
            transform="translate(-3308.211 -3360.854)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.3"
          />
        </g>
        <g transform="translate(3267.508 3190.421)">
          <path
            d="M3369.99,3425.516a2.882,2.882,0,1,1,2.882-2.882A2.885,2.885,0,0,1,3369.99,3425.516Zm0-4.557a1.675,1.675,0,1,0,1.675,1.675A1.676,1.676,0,0,0,3369.99,3420.959Z"
            transform="translate(-3367.108 -3419.752)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.3"
          />
        </g>
        <g transform="translate(3266.097 3174.608)">
          <path
            d="M3355.046,3245.006a4.293,4.293,0,1,1,4.293-4.293A4.3,4.3,0,0,1,3355.046,3245.006Zm0-7.378a3.085,3.085,0,1,0,3.085,3.085A3.089,3.089,0,0,0,3355.046,3237.628Z"
            transform="translate(-3350.753 -3236.421)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.3"
          />
        </g>
        <g transform="translate(3261.713 3205.399)">
          <path
            d="M3301.921,3596.778h-.1a1.9,1.9,0,0,1-1.9-1.9v-.874a.6.6,0,0,1,.6-.6h2.684a.6.6,0,0,1,.6.6v.874A1.9,1.9,0,0,1,3301.921,3596.778Zm-.787-2.167v.27a.69.69,0,0,0,.689.689h.1a.69.69,0,0,0,.689-.689v-.27Z"
            transform="translate(-3299.927 -3593.404)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.3"
          />
        </g>
        <g transform="translate(3275.089 3205.399)">
          <path
            d="M3456.994,3596.778h-.1a1.9,1.9,0,0,1-1.9-1.9v-.874a.6.6,0,0,1,.6-.6h2.684a.6.6,0,0,1,.6.6v.874A1.9,1.9,0,0,1,3456.994,3596.778Zm-.787-2.167v.27a.69.69,0,0,0,.689.689h.1a.69.69,0,0,0,.69-.689v-.27Z"
            transform="translate(-3455 -3593.404)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.3"
          />
        </g>
      </g>
    </svg>
  );
};
